export function getValueFromCookie(name, cookie = document.cookie) {
    var _a, _b;
    return (_b = (_a = cookie.match(new RegExp(`(?:${name}=)(.*?)(?:;|$)`))) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null;
}
